/*
 * @Author: withease-partner+cao@hashdash-group.com
 * @Description: the frame page of 「input上面的label」
 */
<template>
  <p class="cInputTitle-container" v-html="$sanitize(text)"></p>
</template>


<script>
export default {
  props: ['text'],
  methods: {}
};
</script>

<style lang="less"  scoped>
.cInputTitle-container {
  margin-bottom: 0.08rem;
  font-size: 0.16rem;
  line-height: 0.21rem;
  color: #333333;
  font-weight: 500;
  min-height: 0.21rem;
}
</style>



// WEBPACK FOOTER //
// src/components/Title/cInputTitle.vue